import React from 'react';
import styled from 'styled-components';
import CaseStudyTextWithTitle from './CaseStudyTextWithTitle';
import CaseStudyTestimonial from '../case-study-testimonial/CaseStudyTestimonial';
import CaseStudySolution from '../case-study-solution/CaseStudySolution';
import CaseStudyProjectResults from '../case-study-project-results/CaseStudyProjectResults';
import CaseStudyProjectCard from '../case-study-project-card/CaseStudyProjectCard';
import CaseStudyLargeImage from '../case-study-large-image/CaseStudyLargeImage';
import CaseStudyCallToAction from '../case-study-call-to-action/CaseStudyCallToAction';

const CaseStudyContentContainer = styled.div``;

export default function CaseStudyContent({ content }: { content: any[] }) {
  return (
    <CaseStudyContentContainer>
      {content &&
        content?.map((item: any, index: number) => (
          <ContentRenderer item={item} key={index} />
        ))}
    </CaseStudyContentContainer>
  );
}

const ContentRenderer = ({ item }: { item: any }) => {
  switch (item.component) {
    case 'caseStudyTextWithTitle':
      return (
        <CaseStudyTextWithTitle
          label={item.label}
          title={item.title}
          content={item.content}
        />
      );
    case 'caseStudyLargeImage':
      return <CaseStudyLargeImage image={item.image} />;
    case 'caseStudyTestimonial':
      return (
        <CaseStudyTestimonial
          quote={item.quote}
          quoteeName={item.quoteeName}
          quoteeRole={item.quoteeRole}
          associatedCompanyLogo={item.associatedCompanyLogo}
          associatedCompanyDescription={item.associatedCompanyDescription}
        />
      );
    case 'caseStudySolution':
      return (
        <CaseStudySolution
          title={item.title}
          solutionItems={item.solutionItems}
          solutionDescription={item.solutionDescription}
        />
      );
    case 'caseStudyProjectResults':
      return (
        <CaseStudyProjectResults
          title={item.title}
          statItems={item.statItems}
          benefitsTitle={item.benefitsTitle}
          benefitItems={item.benefitItems}
        />
      );
    case 'caseStudyCallToAction':
      return <CaseStudyCallToAction {...item} />;
    case 'caseStudyNextProjectCard':
      return (
        <CaseStudyProjectCard
          label={item.label}
          caseStudy={item.caseStudy}
          infoItems={item.infoItems}
        />
      );
    default:
      return null;
  }
};
